/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-button-toggle-appearance-standard.mat-button-toggle-checked[ng-reflect-value=true][_ngcontent-%COMP%]{background-color:#8ccd8b;color:#fff}.input_n[_ngcontent-%COMP%]{margin-top:26px}.input_n[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-left:5px solid #42a948}.disabled[_ngcontent-%COMP%]{color:gray!important}\n/*# sourceMappingURL=machinesetting.component.css.map*/"];
export { styles as styles };
